import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchSameDayBags = createAction(ACTION.FETCH_SAME_DAY_BAGS.REQUEST, (bagId) => ({bagId}));
export const clearState = createAction(ACTION.CLEAR_STATE);
